import { render, staticRenderFns } from "./finaly.vue?vue&type=template&id=72a5db36&scoped=true&"
import script from "./finaly.vue?vue&type=script&lang=js&"
export * from "./finaly.vue?vue&type=script&lang=js&"
import style0 from "./finaly.vue?vue&type=style&index=0&id=72a5db36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a5db36",
  null
  
)

export default component.exports